class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  open() {
    const notification = document.getElementById('cart-notification');
    const overlay = document.getElementById('nv-overlay');
    if (notification) notification.classList.add('active');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.body.addEventListener('click', this.onBodyClick);

    fetch('/cart.js').then(r => r.json()).then(cart => {
      const total = (cart.total_price / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
      const totalEl = document.getElementById('nv-total');
      const checkoutEl = document.getElementById('nv-checkout-total');
      const viewEl = document.getElementById('nv-view-cart');
      if (totalEl) totalEl.textContent = total;
      if (checkoutEl) checkoutEl.textContent = total;
      if (viewEl) viewEl.textContent = 'View cart (' + cart.item_count + ')';
    });
  }

  close() {
    const notification = document.getElementById('cart-notification');
    const overlay = document.getElementById('nv-overlay');
    if (notification) notification.classList.remove('active');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
    document.body.removeEventListener('click', this.onBodyClick);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (el) {
        el.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (!target.closest('#cart-notification') && !target.closest('[name="add"]')) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);